/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { NotificationContext } from '../../../contexts/Notification';

function EditDepartmentModal({
  department, isEditing, closeModal, onDepartmentSaved, workspaceId,
}) {
  const { displayNotification } = useContext(NotificationContext);
  const [isSaving, setIsSaving] = useState(false);
  const [name, setName] = useState(department?.name ?? '');
  const [formErrors, setFormErrors] = useState({});

  const handleSaveDepartment = async () => {
    setIsSaving(true);
    const { data, success } = await sendRequest({
      method: 'post',
      url: API.WORKSPACE.department(workspaceId),
      data: { name, id: department?.id ?? null },
    });
    if (success) {
      onDepartmentSaved();
      closeModal();
      displayNotification({ message: 'Department saved successfully.', severity: 'success' });
    } else {
      setFormErrors(data || {});
      displayNotification({ message: 'Error occurred while saving department.', severity: 'error' });
    }
    setIsSaving(false);
  };

  const disabled = isSaving || !name || (department ? department.name === name : false);

  return (
    <Modal open onClose={closeModal} className="flex-row align-c jstfy-c">
      <Box style={{ width: 489, maxWidth: 'calc(100% - 32px)', padding: 24, background: '#fff', borderRadius: 12 }}>
        <h5 className="text-lg font-semibold leading-none text-ink-900 mb-5">{`${isEditing ? 'Edit' : 'Add'} Department`}</h5>
        <div className="mb-5">
          <span className="block text-sm font-medium text-ink-900 mb-1.5">Department Name</span>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Engineering"
            className="w-full h-10 px-3 border border-rule rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none focus:border-brand-500"
            style={{ borderStyle: 'solid' }}
          />
          {formErrors?.name ? <p className="text-xs text-[#CC4525] mt-1.5">{formErrors.name}</p> : null}
        </div>
        <div className="flex justify-start items-center gap-2">
          <button
            type="button"
            onClick={closeModal}
            className="inline-flex items-center justify-center px-4 py-2 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition"
            style={{ borderStyle: 'solid' }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSaveDepartment}
            disabled={disabled}
            className="inline-flex items-center justify-center px-4 py-2 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition"
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {isSaving ? 'Saving…' : isEditing ? 'Save Changes' : 'Save Department'}
          </button>
        </div>
      </Box>
    </Modal>
  );
}

EditDepartmentModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onDepartmentSaved: PropTypes.func.isRequired,
  department: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  isEditing: PropTypes.bool.isRequired,
  workspaceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

EditDepartmentModal.defaultProps = { department: {} };

export default EditDepartmentModal;
